import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'
import { createDate, compareAsc, isDate } from 'core/utils/date'

import {
  type PendingResponse,
  createTenderPendingResponse,
} from '../../domain/Tender/PendingResponse'
import { TenderRepository } from '../../infra/Tender/TenderRepository'

function getDate(pendingResponse: PendingResponse): Date | undefined {
  if (pendingResponse.type === 'tender') {
    return pendingResponse.value.deadline
  } else {
    return createDate(pendingResponse.value.expires_at)
  }
}

export type FactoryDependencies = {
  tenderRepository: TenderRepository
}

export function getListOfPendingTendersFactory({ tenderRepository }: FactoryDependencies) {
  return async function getListOfPendingTendersImpl(config?: {
    signal?: AbortSignal
  }): Promise<Array<PendingResponse>> {
    const pendingTendersResult = await tenderRepository.getPendingTenders(config)

    const pendingTenders = pendingTendersResult.map(createTenderPendingResponse)

    pendingTenders.sort((left, right) => {
      const dateLeft = getDate(left)
      const dateRight = getDate(right)

      if (isDate(dateLeft) && isDate(dateRight)) {
        return compareAsc(dateLeft, dateRight)
      } else if (!isDate(dateLeft) && isDate(dateRight)) {
        return 1
      } else if (isDate(dateLeft) && !isDate(dateRight)) {
        return -1
      } else {
        return 0
      }
    })

    return pendingTenders
  }
}

export function getListOfPendingTenders(config?: {
  signal?: AbortSignal
}): Promise<Array<PendingResponse>> {
  const httpClient = new HttpClient(API_URL)

  const tenderRepository = new TenderRepository({ httpClient })
  const newGetListOfPendingTenders = getListOfPendingTendersFactory({
    tenderRepository,
  })
  return newGetListOfPendingTenders(config)
}
